import { InjectionToken } from '@angular/core';
import { IDateConfig } from '../model';

export const DATE_CONFIG = new InjectionToken<IDateConfig>('DATE_CONFIG');
